import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const m = e((s, t) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: t,
    ...s,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M15.666 4.221A1.99 1.99 0 0 0 14.25 2.83C13.003 2.5 8 2.5 8 2.5s-5.003 0-6.251.329A1.99 1.99 0 0 0 .334 4.221C0 5.45 0 8.011 0 8.011s0 2.562.334 3.79c.184.678.727 1.189 1.415 1.37C2.997 13.5 8 13.5 8 13.5s5.003 0 6.251-.329c.689-.181 1.23-.692 1.415-1.37.334-1.228.334-3.79.334-3.79s0-2.562-.334-3.79m-9.302 6.116V5.685l4.181 2.326z"
          }
        )
      }
    )
  }
));
m.displayName = "YoutubeIcon";
export {
  m as YoutubeIcon,
  m as default
};
//# sourceMappingURL=index.js.map
